// extracted by mini-css-extract-plugin
export default {"info":"info_info__UGyPv","center":"info_center__ngF0G","shortInfo":"info_shortInfo__xXAzd"};